import Marquee from "react-fast-marquee";

const items = ["Dark Trance", "Dub Weight", "Sub Bass", "160 BPM", "Bristol Sound", "Low End Theory"];

export const StrokeMarquee = () => {
  return (
    <section className="relative border-y border-line bg-ink py-6 sm:py-9 overflow-hidden" data-testid="marquee-section">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="stroke-text font-display font-black uppercase text-5xl sm:text-7xl lg:text-8xl tracking-tighter px-6 sm:px-10">
              {t}
            </span>
            <span className="text-acid text-3xl sm:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default StrokeMarquee;
